<script setup lang="ts">
import { useAppConfig } from '@/shared/composables/useAppConfig.ts';
import {
  computed,
  onMounted,
  ref,
  watch,
} from 'vue';

const props = defineProps<{
  closeDelay?: number;
}>();

const { contentContainerLeftPaddingSmall } = useAppConfig();

const closeDelaySec = computed(() => {
  return ((props.closeDelay || 0) / 1000) + 's';
});

const timerIndicatorActive = ref(false);

onMounted(() => {
  if (props.closeDelay) {
    timerIndicatorActive.value = true;
  }
});

watch(() => props.closeDelay, (newValue) => {
  if (newValue) {
    timerIndicatorActive.value = true;
  }
});

</script>

<template>
  <div
    class="snackbar"
  >
    <slot />
    <div class="circle-progress-wrapper">
      <div class="wrapper right">
        <div
          class="circle-progress right-circle"
          :class="{'right-cartoon': timerIndicatorActive}"
        />
      </div>
      <div class="wrapper left">
        <div
          class="circle-progress left-circle"
          :class="{'left-cartoon': timerIndicatorActive}"
        />
      </div>
    </div>

    <div class="blur-circle" />
  </div>
</template>

<style scoped>
.snackbar {
  position: relative;
  padding: 22px;
  border-radius: 12px;
  background: #121212;
  width: calc(100% - (2px * v-bind(contentContainerLeftPaddingSmall)));
  /* position: absolute; */
  z-index: 500;
  /* top: 0;
  left: 50%;
  transform: translate(-50%, 0%); */
  margin: auto;

  display: flex;
  align-items: center;
  justify-content: space-between;
  column-gap: 12px;

  color: #FFF;
  font-family: var(--fontFamily);
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;

  --ttmerProgressLineColor: #ADAEAF;

  overflow: hidden;
}

.circle-progress-wrapper {
  position: relative;
  width: 22px;
  height: 22px;
  text-align: center;
  line-height: 22px;
  flex-shrink: 0;
}
.right {
  right: 0;
}
.wrapper{
  position: absolute;
  width: 11px;
  height: 22px;
  top: 0;
  overflow: hidden;
}
.circle-progress{
  width: 18px;
  height: 18px;
  border: 2px solid rgba(173,174,175,0.2);
  border-radius: 50%;
  box-sizing: content-box;
  position: absolute;
  top: 0;
}
.right-circle{
  border-top: 2px solid var(--ttmerProgressLineColor);
  border-right: 2px solid var(--ttmerProgressLineColor);
  right: 0;
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
}
.left-circle{
  border-bottom: 2px solid var(--ttmerProgressLineColor);
  border-left: 2px solid var(--ttmerProgressLineColor);
  left: 0;
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
}
.right-cartoon {
  -webkit-animation: circleProgressLoad_right v-bind(closeDelaySec) linear forwards;
  animation: circleProgressLoad_right v-bind(closeDelaySec) linear forwards;
}
.left-cartoon {
  -webkit-animation: circleProgressLoad_left v-bind(closeDelaySec) linear forwards;
  animation: circleProgressLoad_left v-bind(closeDelaySec) linear forwards;
}

@keyframes circleProgressLoad_left {
  0% {
    -webkit-transform: rotate(46deg);
    transform: rotate(46deg)
  }

  50%,to {
    -webkit-transform: rotate(-136deg);
    transform: rotate(-136deg)
  }
}

@keyframes circleProgressLoad_right {
  0%,50% {
    -webkit-transform: rotate(46deg);
    transform: rotate(46deg)
  }

  to {
    -webkit-transform: rotate(-136deg);
    transform: rotate(-136deg)
  }
}

.blur-circle {
  position: absolute;
  width: 144px;
  height: 144px;
  bottom: -90px;
  left: 50%;
  transform: translateX(-50%);
  border-radius: 50%;
  background: rgba(133, 58, 255, 1);
  filter: blur(100px);
  z-index: -1;
}
</style>
